import {
  Alert,
  AlertIcon,
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useDeleteCohort } from "../../../services/api/cohorts/mutations/useDeleteCohort";
import { ICohort } from "../../registries/models/Cohort";

interface IProps {
  cohort: ICohort;
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteCohortModal = ({ onClose, isOpen, cohort }: IProps) => {
  const toast = useToast();

  const {
    mutateAsync: mutateAsyncDeleteCohort,
    isLoading: isLoadingDeleteCohort,
    isError: isErrorDeleteCohort,
    reset: resetDeleteCohort,
  } = useDeleteCohort();

  const handleOnClose = () => {
    resetDeleteCohort();
    onClose();
  };

  const handleSuccess = () => {
    handleOnClose();
  };

  const handleOnAction = async () => {
    // Post data to api
    try {
      await mutateAsyncDeleteCohort(cohort.id, {
        onSuccess: handleSuccess,
      });
      toast({
        title: "Cohort removed",
        description: ``,
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      toast({
        title: "Failed to remove cohort",
        description: ``,
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      closeOnOverlayClick={true}
      size="3xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Cohort</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack>
            <Text textStyle={"title"}>{cohort.title}</Text>
            <Text textStyle={"description"}>{cohort.description}</Text>

            {isErrorDeleteCohort && (
              <Alert status="error" variant={"solid"}>
                <AlertIcon />
                <Text>Failed to delete cohort, please refresh</Text>
              </Alert>
            )}
          </Stack>
        </ModalBody>

        <ModalFooter>
          <ButtonGroup isDisabled={isErrorDeleteCohort}>
            <Button onClick={onClose}>Close</Button>

            <Button
              type="submit"
              isLoading={isLoadingDeleteCohort}
              loadingText="Delete cohort"
              onClick={handleOnAction}
              colorScheme={"orange"}
            >
              Delete
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
